import { Box } from "@mantine/core";

const HERO_IMAGES = [
  "/images/hero/VIDthumb_ADV1_UKSD_BD.webp",
  "/images/hero/ADV3_SCBP_.webp",
  "/images/hero/IMP3_RectangleSaida.webp",
  "/images/hero/VIDthumb_Imp1_BoxWS_FA.webp",
  "/images/hero/VIDthumb_Imp2_SwivelWS_BD.webp",
  "/images/hero/VIDthumb_Imp2_WSRSSPE_FA.webp",
  "/images/hero/VIDthumb_Imp3_JKWS_FA.webp",
  "/images/hero/VIDthumb_INT1_Follows270_BD.webp",
  "/images/hero/4FS-OverheadTurn.webp",
  "/images/hero/INT3_TBEBTBC_.webp",
  "/images/hero/INT4_BTBLL_.webp",
  "/images/hero/IMP1_62_.webp",
];

export function HomeHeroBackground() {
  return (
    <Box
      aria-hidden
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 0,
        pointerEvents: "none",
        overflow: "hidden",
      }}
    >
      <Box
        style={{
          position: "absolute",
          inset: 0,
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
          gridAutoRows: "124px",
          gap: 8,
          padding: 8,
          opacity: 0.14,
          filter: "saturate(0.9) contrast(1.05)",
        }}
      >
        {Array.from({ length: 120 }, (_, i) => HERO_IMAGES[i % HERO_IMAGES.length]).map(
          (src, i) => (
            <Box
              key={i}
              style={{
                backgroundImage: `url(${src})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderRadius: 6,
              }}
            />
          )
        )}
      </Box>

      <Box
        style={{
          position: "absolute",
          inset: 0,
          background: `
            radial-gradient(ellipse at 20% 40%, rgba(255, 152, 0, 0.28) 0%, transparent 55%),
            radial-gradient(ellipse at 80% 15%, rgba(255, 193, 7, 0.20) 0%, transparent 55%),
            radial-gradient(ellipse at 50% 100%, rgba(23, 23, 23, 0.85) 0%, transparent 60%),
            linear-gradient(180deg, rgba(23, 23, 23, 0.45) 0%, rgba(23, 23, 23, 0.65) 100%)
          `,
        }}
      />
    </Box>
  );
}
